<template>
    <div class="h-100 bg-white bd-radius-5">
        <b-card-body>
            <b-card-text class="p-0 scroll-bar-pop card-tab">
                <!-- <div class="row d-flex justify-content-end">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>
                                เรียงตาม
                            </label>
                            <v-select 
                                class="w-100"
                                label="name"
                                v-model="tmpCourier.filterCode" 
                                :options="typeFilter"
                                :reduce="type => type.code"
                            ></v-select> 
                        </div>
                    </div>
                </div> -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="scroll-table scroll-bar-pop scrollbar-style table-responsive">
                            <span class="scroll-empty text-primary" v-if="tmpCheckPrice.isLoading">
                                <i class="fas fa-circle-notch fa-spin fa-2x"></i>
                            </span>
                            <h3 class="scroll-empty text-muted" v-else-if="listCourier.length < 1">
                                กรุณากรอกรายละเอียดพัสดุ
                            </h3>
                            <table class="table" v-else-if="!tmpCheckPrice.isLoading && listCourier.length > 0">
                                <thead>
                                    <tr class="text-center">
                                        <th colspan="2">รายชื่อขนส่ง</th>
                                        <!-- <th>ระยะเวลาจัดส่ง</th> -->
                                        <th>ราคาขนส่ง</th>
                                        <th>การจัดการ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item,index) in listCourier" >
                                        <tr
                                            :key="index"
                                            class="text-center"
                                            :class="[(item.price == 0 || !item.status) ? 'filter-gray' : '']"
                                        >
                                            <td class="w-25">
                                                <img :src="item.src" img-alt="courierIcon" width="150" height="70" />
                                                
                                            </td>
                                            <td class="text-left w-25">
                                                <h4>{{item.courier_name}}</h4>
                                                <div class="line-height-1" v-if="!item.status">
                                                    <small class="text-yellow">* {{errorCheckPrice(item)}}</small>
                                                </div>
                                            </td>
                                            <!-- <td>1-3 วัน</td> -->
                                            <td>
                                                {{item.price | numFormat('0,0.00')}}
                                                <br v-if="item.remote_area > 0" />
                                                <span class="small text-danger tooltip-target-1" v-if="item.remote_area > 0"
                                                    v-b-tooltip title="ค่าบริการพิ้นที่พิเศษ">(+ {{ item.remote_area }})</span>
                                                <br v-if="item.travel_surcharge > 0" />
                                                <span class="small text-danger tooltip-target-1" v-if="item.travel_surcharge > 0"
                                                    v-b-tooltip title="ค่าบริการพื้นที่ท่องเที่ยว">(+ {{ item.travel_surcharge }})</span>
                                                <br v-if="item.island_surcharge > 0" />
                                                <span class="small text-danger tooltip-target-1" v-if="item.island_surcharge > 0"
                                                    v-b-tooltip title="ค่าพื้นที่หมู่เกาะ">(+ {{ item.island_surcharge }})</span>
                                                <br v-if="item.fuel_surcharge > 0" />
                                                <span class="small text-danger tooltip-target-1" v-if="item.fuel_surcharge > 0"
                                                    v-b-tooltip title="Additional Fuel Charge">(+ {{ item.fuel_surcharge }})</span>
                                                <br v-if="item.service_price_inter > 0" />
                                                <span class="small text-danger tooltip-target-1" v-if="item.service_price_inter > 0"
                                                    v-b-tooltip title="ค่าบริการขนส่งพัสดุต่างประเทศ">(+ {{ item.service_price_inter }})</span>
                                            </td>
                                            <td>
                                                <b-button
                                                    variant="primary"
                                                    :disabled="item.price == 0 || !item.status"
                                                    @click="$emit('selectedCourier' , item)"
                                                >
                                                    เลือกขนส่ง 
                                                </b-button>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table> 
                        </div>
                    </div>
                </div>
            </b-card-text>
        </b-card-body>
    </div>
</template>

<script>
import { errorCheckPrice } from '@/plugins/index'

export default {
    props:{
        tmpCheckPrice: Object
    },
    data: () => ({
        listCourier: [],
        errorCheckPrice: errorCheckPrice
        // typeFilter: [
        //     {
        //         code : 'LOW_PRICE',
        //         name : 'ราคาถูกสุด',
        //     }
        // ],
        // tmpCourier: {
        //     filterCode: 'LOW_PRICE',
        // }
    })
}
</script>
